// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';

// Data
const state = {
	settings:[],
	setting: {},
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getSettings: ({ dispatch }) => {
		api.settings.index()
			.then(response => dispatch('setSettings', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getSetting: ({ dispatch }, id) => {
		api.settings.show(id)
			.then(response => dispatch('setSetting', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
